module.exports = __webpack_public_path__ + "img/9791186036440.ff7f1921.jpg";